var _path, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBalanced = function SvgBalanced(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 58,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__a",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.769.585h116.38v57.151H.769z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__b",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.959,
    cy: 59.366,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    stroke: "#C0EEC0",
    d: "m53.886 53.554 3.41-1.2L40.37 2.796l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__c",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.959,
    cy: 59.366,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    d: "M57.246 50.446 40.353.469l18.403-4.253L77.836.028l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__d",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.959,
    cy: 59.366,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    d: "M107.077 23.4 68.464 49.775l3.868 7.525h46.348l-3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__e",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.959,
    cy: 59.366,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    d: "m10.84 23.4 38.613 26.375-3.869 7.525H-.763l3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "balanced_svg__f",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.959,
    cy: 59.366,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#balanced_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    d: "m65.323 52.15-3.43-1.142L77.996 1.176l18.484 8.671 10.862 13.722z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.958,
    cy: 59.372,
    r: 26.263,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m55.488 42.108 3.87-3.762 3.85 3.96M59.33 56.343l.029-16.5"
  })));
};
export { SvgBalanced as ReactComponent };
export default __webpack_public_path__ + "images/balanced.svg";